<template>
  <div>
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88665 9.32652C8.07385 9.22553 8.19055 9.03349 8.19055 8.82463V5.57227H14.6124C14.9367 5.57227 15.1998 5.3152 15.1998 4.99846C15.1998 4.68171 14.9367 4.42465 14.6124 4.42465H8.19055V1.17229C8.19055 0.962657 8.07385 0.770621 7.88665 0.670396C7.69945 0.56864 7.47075 0.575525 7.28982 0.686462L1.07397 4.51263C0.903217 4.61821 0.799829 4.80107 0.799829 4.99846C0.799829 5.19585 0.903217 5.3787 1.07397 5.48428L7.28982 9.31045C7.38537 9.3686 7.49424 9.39844 7.60311 9.39844C7.70024 9.39844 7.79814 9.37395 7.88665 9.32652Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
    name: 'ArrowIcon',
};
</script>
